import * as d3 from 'd3'

export default {

  methods: {

    draw_Table() {
      let tbl = this.table
      let col = this.columns
      let title = this.table.title
      let val = this.table.value

      let Table = this.canvasForms
      .append('g')
      .attr('transform', `translate(0.5, 0.5)`)

      this.rawData.forEach((d,i)=> {

        let y_ = i * tbl.lineHeight

        // Title
        Table
        .append('text')
        .attr('x', title.align == 'start' ? 0 : title.width)
        .attr('y', y_ + tbl.textY + title.tSize*0.4)
        .attr('fill', col[i].text).attr('font-size', title.tSize)
        .attr('text-anchor', title.align)
        .attr('font-family', 'roboto')
        .text(d.TITLE)


        // Value
        Table
        .append('rect')
        .attr('x', title.width)
        .attr('y', y_)
        .attr('width', val.width)
        .attr('height', val.height)
        .attr('fill', col[i].fill)
        .attr('stroke', col[i].stroke).attr('stroke-width', col[i].sWidth)
        .attr('opacity', val.opacity)
        
        Table
        .append('text')
        .attr('id', `VAL_${this.localId}_${i}`)
        .attr('x', () => {
          let x_ = title.width
          if(val.align == 'start') x_ = x_ + val.padding
          if(val.align == 'middle') x_ = x_ + (val.width/2)
          if(val.align == 'end') x_ = x_ + val.width - val.padding
          return x_
        })
        .attr('y', y_ + tbl.textY + val.tSize*0.4)
        .attr('fill', col[i].value).attr('font-size', val.tSize)
        .attr('text-anchor', val.align)
        .attr('font-family', 'roboto')
        .text(this.gmx_numFormat(d.VALUE, col[i].unit))
        .call(this.event_Link, col[i], i)
      }) 
    },

  } 
}